import { render, staticRenderFns } from "./confirmFormFromEmail.vue?vue&type=template&id=5f71b1bb&scoped=true"
import script from "./confirmFormFromEmail.vue?vue&type=script&lang=js"
export * from "./confirmFormFromEmail.vue?vue&type=script&lang=js"
import style0 from "./confirmFormFromEmail.vue?vue&type=style&index=0&id=5f71b1bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71b1bb",
  null
  
)

export default component.exports